(ns app.front.view.wizard.attachment-selector
  (:require [app.domain.workspace.model :as workspace-model]
            [app.front.ui.table :as ui-table]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.attachment.list :as attachment-list]
            [app.front.view.attachment.subs :as attachment-subs]
            [app.front.view.wizard.buttons :as wizard-buttons]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::selected-attachments
  (fn [db _]
    (get db ::selected-attachments #{})))


(rf/reg-event-db ::init
  (fn [db _]
    (assoc db ::selected-attachments #{})))


(rf/reg-event-db ::set-selected-attachments
  (fn [db [_ ids]]
    (update db ::selected-attachments
            (fn [selected]
              (->> ids
                   (reduce (fn [selected id]
                             (if (some selected [id])
                               (disj selected id)
                               (conj selected id)))
                           (set selected)))))))


(defn attachments [{:keys [tr next-page back]}]
  (let [application      (<sub [::ws-subs/application])
        related-targets  (workspace-model/get-related-targets application)
        all-target-ids   (->> (cons application related-targets)
                              (map :db/id))
        any-attachments? (<sub [::attachment-list/any-attachments? all-target-ids])]
    [:section
     (if any-attachments?
       [attachment-list/list-row
        [attachment-list/filters {:target-ids all-target-ids}]
        [attachment-list/stateless-attachment-table {:process-target-id (:db/id application)
                                                     :workspace-id      (-> application :entity/parent :workspace/id)
                                                     :editable?         false
                                                     :selected          (<sub [::selected-attachments])
                                                     :on-select         #(>evt [::set-selected-attachments %])}]
        [attachment-list/related-workspace-attachments {:targets related-targets}]]
       [:div.no-attachments
        {:class (when-not any-attachments? "mt-8")}
        (tr [:wizard/no-attachments])])
     [wizard-buttons/buttons tr {:next {:on-click next-page
                                        :text     (tr [:next])}
                                 :back {:on-click back}}]]))


(defn- attachment-type [{:db/keys [id]}]
  (let [types (<sub [::attachment-subs/attachment-types id])]
    (attachment-common/attachment-types-text types)))


(defn selected-attachments-summary [tr]
  (let [application          (<sub [::ws-subs/application])
        process-target-id    (:db/id application)
        related-targets      (workspace-model/get-related-targets application)
        all-target-ids       (->> (cons application related-targets)
                                  (map :db/id))
        any-attachments?     (<sub [::attachment-list/any-attachments? all-target-ids])
        attachments          (<sub [::attachment-subs/attachments-for-parent process-target-id])
        selected-ids         (<sub [::selected-attachments])
        selected-attachments (->> attachments
                                  (filter #(contains? selected-ids (:db/id %))))]
    [:div.my-8
     [:h3 (tr [:wizard/selected-attachments])]
     (if any-attachments?
       [ui-table/modern-responsive-table
        {:items selected-attachments
         :tr    tr
         :cols  [[:attachment/type attachment-type {}]
                 [:attachment/drawing-number :attachment/drawing-number {}]
                 [:attachment/contents :attachment/contents {}]]}]
       [:div.no-attachments
        {:class (when-not (seq selected-attachments) "mt-8")}
        (tr [:attachments/none])])]))
